import { gateway } from "../../../../../gateway";

interface GetJobEventsParams {
  jobId: number;
  page?: number;
  pageSize?: number;
  order?: "ASC" | "DESC" | "RELEVANCE";
  orderBy?: "startDate" | "createdAt" | "updatedAt";
  status?: string;
  startDate?: string;
  endDate?: string;
  /** NOT_PAID / PAID filter visits by invoice state on the job-events endpoint. */
  billingStatus?: string;
}

export const getJobEvents = async ({
  jobId,
  page = 1,
  pageSize,
  order = "ASC",
  orderBy,
  status,
  startDate,
  endDate,
  billingStatus,
}: GetJobEventsParams) => {
  const token = sessionStorage.getItem("token");

  const params: Record<string, any> = {
    page,
    pageSize,
    order,
  };

  if (status && status !== "ALL") {
    params.status = status;
  }
  if (orderBy) {
    params.orderBy = orderBy;
  }
  if (startDate) {
    params.startDate = startDate;
  }
  if (endDate) {
    params.endDate = endDate;
  }
  if (billingStatus) {
    params.billingStatus = billingStatus;
  }

  const response = await gateway.get(`/jobs/events/${jobId}`, {
    params,
    headers: {
      Authorization: `${token}`,
    },
  });

  return response.data.data;
};
